import { useState } from "react";
import { PlayCircle, X, Volume2, ChevronLeft } from "lucide-react";
import { buildStreamIframeUrl } from "@/lib/cloudflareStreamPlayer";

const TUTORIAL_URL = buildStreamIframeUrl({
  videoId: "60c41bccbef0031e42305343d1023bd7",
  subdomain: "customer-4ks14eaibvwflhwd.cloudflarestream.com",
  native: true,
});

// Settings row "شرح التطبيق" → Arabic app tour video (Arabic UI only).
export default function AppTutorialButton() {
  const [open, setOpen] = useState(false);
  return (
    <>
      <button
        onClick={() => setOpen(true)}
        className="w-full bg-white rounded-3xl p-4 flex items-center justify-between border border-neutral-100"
        data-testid="settings-app-tutorial-btn"
      >
        <div className="flex items-center gap-3">
          <div className="w-11 h-11 rounded-2xl bg-brand-50 text-brand-600 flex items-center justify-center">
            <PlayCircle className="w-5 h-5" />
          </div>
          <div className="text-start">
            <div className="font-bold text-neutral-800">شرح التطبيق</div>
            <div className="text-xs text-neutral-500">فيديو يشرح لك كل مميزات كالوفاي</div>
          </div>
        </div>
        <ChevronLeft className="w-4 h-4 text-neutral-400 flex-shrink-0" />
      </button>

      {open && (
        <div className="fixed inset-0 z-[100] bg-black/90 flex flex-col items-center justify-center p-4" dir="rtl" data-testid="app-tutorial-modal">
          <button
            onClick={() => setOpen(false)}
            className="absolute top-[max(1rem,env(safe-area-inset-top))] left-4 w-10 h-10 rounded-full bg-white/15 text-white flex items-center justify-center"
            aria-label="إغلاق"
            data-testid="app-tutorial-close-btn"
          >
            <X className="w-5 h-5" />
          </button>
          <div className="flex items-center gap-2 text-white text-sm font-bold mb-3">
            <Volume2 className="w-4 h-4 text-brand-400" />
            ارفع الصوت عشان تسمع الشرح
          </div>
          <div className="relative w-full max-w-[360px] aspect-[9/17] rounded-3xl overflow-hidden bg-black">
            <iframe
              src={TUTORIAL_URL}
              title="شرح تطبيق كالوفاي"
              allow="accelerometer; gyroscope; autoplay; encrypted-media; picture-in-picture"
              allowFullScreen
              className="absolute inset-0 w-full h-full border-0"
              data-testid="app-tutorial-iframe"
            />
          </div>
        </div>
      )}
    </>
  );
}
